module.exports = __webpack_public_path__ + "img/card-logos.87e946cc.svg";